import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Typo, Icon, Form, ReviewStar, HR } from 'tmt-ui-kit';

// import ReviewStar from '~/components/Reviews/ReviewStar';
import PriceBlock from './PriceBlock';

// import { getRatingPoint } from '~/utils/helpers';

const GroupedTripSelector = dynamic(
  () => import(/* webpackChunkName: "TripDetail.RequestBookV2.components" */'../RequestBookV2/GroupedTripSelector'),
  { loading: () => null, ssr: false }
);

const { Button } = Form;

const Chevron = styled(Icon)`
  font-size: 36px;
`;

const Container = styled.div`
  @media (min-width: 1201px) {
    display: none;
  }
  z-index: 99;
  position: fixed;
  left: 0;
  padding: 0 16px;
  bottom: ${props => (props.isGDPR ? 80 : 0)}px;
  right: 0;
  height: 70px; /* calc(100vh - 90px); */
  border-top: solid 1px ${props => props.theme.blueGray};
  background-color: ${props => props.theme.white};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  /* transition: all 1s ease-in-out; */
  @media only screen and (max-width: 1200px){
    bottom: ${props => (props.isGDPR ? '35px' : '0px')};
  }
  @media only screen and (max-width: 931px){
    bottom: ${props => (props.isGDPR ? '60px' : '0px')};    
  }
  @media only screen and (max-width: 514px){
    bottom: ${props => (props.isGDPR ? '80px' : '0px')};
    
  }
  @media only screen and (max-width: 356px){
    bottom: ${props => (props.isGDPR ? '100px' : '0px')};
  }
`;

const TripGroupContainer = styled.div`
  position: fixed;
  z-index: 100;
  bottom: 0;
  width: 100%;
  display: none;
  padding: 0 16px;
  border-top: solid 1px ${props => props.theme.blueGray};
  background-color: ${props => props.theme.white};
  @media (max-width: 1200px) {
    ${props => props.showTripGroup && `
      display: block;
    `}
  }
`;

const PaddingForTripGroup = styled.div`
  padding-bottom: 32px;
`;

const ModHR = styled(HR)`
  margin: 0 -16px 16px !important;
`;

const PriceOuter = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
`;

const PriceContainer = styled.div`
  height: 100%;
  letter-spacing: -0.2px;
  flex: 1;
  padding-right: 4px;
  background-color: white;
  position: relative;
  ${props => props.hideMobile && `
    @media(max-width: 600px) {
      display: none;
    }
  `}
  ${props => !props.hideMobile && `
    @media(max-width: 600px) {
      flex: 7;
    }
  `}
  @media(min-width: 601px) and (max-width: 1200px) {
    flex: 2;
  }
`;

const ButtonStyle = css `
  height: 40px;
  @media(max-width: 1200px) and (min-width: 601px) {
    flex: 1;
  }
`;

const MessageButtonContainer = styled.div`
  ${ButtonStyle}
  padding-right: 4px;
  @media(max-width: 600px) {
    display: none;
  }
`;

const BookButtonContainer = styled.div`
  ${ButtonStyle}
  flex: ${props => (props.small ? 'unset !important' : 5)};
`;

const ContactLxContainer = styled.div`
  display: flex;
`;

const TextBold = styled.span`
  font-weight: bold;
  display: block;
`;

const MobileButtonContainer = styled.div`
  position: absolute;
  right: 16px;
  bottom: 78px;
  box-sizing: border-box;
  display: none;
  @media(max-width: 601px) {
    display: block;
  }
`;

const MobileMessageButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: absolute;
  bottom: -5px;
  right: 0;
  user-select: none;
  outline: 0;
  cursor: pointer;
  border: none;
  border-radius: 50%;
  background-color: ${props => props.theme.blue};
  width: 24px;
  height: 24px;
`;

const CustomIcon = styled(Icon)`
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: ${props => props.theme.white};
`;

const CoverContainer = styled.div`
  position: relative;
  margin-left: 24px;
  bottom: 0;
`;

const CoverImageContainer = styled.div`
  position: relative;
  width: 56px;
  border: 2px solid ${props => props.theme.blue};
  height: 56px;
  display: block;
  overflow: hidden;
  border-radius: 50%;
`;

const CoverImage = styled.img`
  display: block;
  height: 100% !important;
  object-fit: cover;
  width: 100%;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  transition: opacity 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);
`;

const MessageButton = styled.button`
  ${props => props.hideMobile && `
    @media(max-width: 700px) {
      display: none;
    }      
  `}
  @media(min-width: 601px) and (max-width: 1200px) {
    display: inline;
  }
  cursor: pointer;
  border-radius: 6px;
  margin-right: 16px;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.white};
  border: solid 1px ${props => props.theme.blueGray};
`;

const MessageText = styled(Typo.Paragraph)`
  color: ${props => props.theme.darkBlue} !important;
  text-align: center;
  line-height: 1;
`;

const CarRentalPax = styled(MessageText)`
  margin-top: 4px;
  padding-left: 2px;
`;

// const BookButton = styled.button`
//   cursor: pointer;
//   border-radius: 6px;
//   /* width: 152px; */
//   width: 100%;
//   height: 100%;
//   background-color: ${props => (props.isMasterTrip ? props.theme.greenLighter : props.theme.orange)};
//   border: none;
//   @media (max-width: 350px) {
//     width: 100%;
//   }
// `;

// const BookText = Typo.HeaderThree.extend`
//   color: ${props => props.theme.white} !important;
//   text-align: center;
//   line-height: 1;
// `;

const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: -6px;
`;

const ReviewStartNoPadding = styled(ReviewStar) `
  margin-right: -4px !important;
`;

const ReviewsCount = styled(Typo.Paragraph)`
  font-size: 10px !important;
  margin-top: 2px !important;
  padding-left: 3px;
  margin-bottom: 0;
`;

const fadeIn = keyframes`
  0% {
    z-index: 100;
    opacity: 0;
  }
  3% {
    opacity: 1;
    z-index: 100;
  }
  33% {
    opacity: 1;
    z-index: 100;
  }
  36% {
    z-index: 100;
    opacity: 0;
  }
  37% {
    z-index: -1;
    opacity: 0;
  }
  100% {
    z-index: -1;
    opacity: 0;
  }
`;

const InsuranceContainer = styled.div`
  color: ${props => props.theme.darkBlue};
  position: absolute;
  line-height: 1.27;
  letter-spacing: -0.1px;
  top: 0px;
  left: 0px;
  background-color: ${props => props.theme.white};
  height: 100%;
  width: 100%;
  display: flex;
  z-index: -1;
  opacity: 0;
  flex-direction: column;
  justify-content: center;
  animation: ${fadeIn} 24s infinite;
  animation-delay: 5s;

  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

const InsuranceHightlight = styled.span`
  font-weight: bold;
  color: ${props => props.theme.greenLighter};
`;

const PriceBackground = styled.div`
  background-color: ${props => props.theme.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const bounce = keyframes`
  from,
  6%,
  17%,
  26%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  13%,
  14% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(-16px, 0, 0);
    transform: translate3d(-16px, 0, 0);
  }

  23% {
    -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    -webkit-transform: translate3d(-7px, 0, 0);
    transform: translate3d(-7px, 0, 0);
  }

  30% {
    -webkit-transform: translate3d(-2px, 0, 0);
    transform: translate3d(-2px, 0, 0);
  }
  32% {
    transform: translate3d(0, 0, 0);
  }
`;

const TextLxContact = styled.p`
  transition: opacity 1s ease;
  background: ${props => props.theme.blueGray};
  border-radius: 6px;
  padding: 8px 18px 8px 14px !important;
  width: 100%;
  height: 100%;
  color: ${props => props.theme.darkBlue};
  position: relative;
  animation-name: ${bounce};
  animation-duration: 3s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;

  &:before {
    content:"";
    position: absolute;
    height: 0px;
    width: 0px;
    top: 14px;
    right: -23px;
    border-width: 12px;
    border-color: transparent transparent transparent ${props => props.theme.blueGray};
    border-style: solid;
  }
`;

const BookButton = ({ instant, label, disabled, onClick = () => {} }) => {
  return instant
    ? <Button.GreenButton disabled={disabled} onClick={onClick}>{label}</Button.GreenButton>
    : <Button.OrangeButton disabled={disabled} onClick={onClick}>{label}</Button.OrangeButton>;
};

const enhance = connect(
  state => ({
    user: state.session.user,
    isGDPR: state.app.isGDPR,
  })
);

class BookBar extends Component {
  state = {
    isHideContact: false,
    isMobileHideTripGroup: true,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isHideContact: true });
    }, 12000);
  }

  toggleMobileTripGroup = () => {
    this.setState((lastState) => ({ isMobileHideTripGroup: !lastState.isMobileHideTripGroup}));
  }

  render() {
    const {
      messageLabel,
      currency,
      price,
      displayPrice,
      bookButtonContainer,
      messageButtonContainer,
      onClickBook,
      onClickMessage,
      ticketPrice,
      trip,
      className,
      isHideReviewRating,
      user,
      isGDPR
    } = this.props;
    const { isHideContact, isMobileHideTripGroup } = this.state;

    const { path } = this.context;
    const { user_id: lx, rating } = trip;

    let carRentalUnit;
    if (trip && trip.product_type === 'car_rental') {
      if (trip.tags && trip.tags.includes('van')) {
        carRentalUnit = 'Van';
      } else {
        carRentalUnit = 'Car';
      }
    }
    const reviewCount = trip.review_count + (trip.travelers_without_review || 0);
    const disabledBook = user._id === lx._id;
    const label = trip.product_type === 'ticket' ? 'Buy It Now' : 'Book';
    const isHideMessage = trip.is_request_form || (trip.is_message_disabled && ['ticket', 'souvenir', 'car_rental'].includes(trip.product_type)) || false;

    const PriceComponent = () => (
      <PriceOuter>
        <PriceContainer hasCrossPrice={!!price} hideMobile={false}>
          {trip && trip.product_type === 'trip' && (
            <InsuranceContainer>
              <div>Book with TakeMeTour </div>
              <div>and get a <InsuranceHightlight> free insurance!</InsuranceHightlight></div>
            </InsuranceContainer>
          )}
          <PriceBackground>
            <PriceBlock
              price={price}
              displayPrice={displayPrice}
              currency={currency}
              ticketPrice={ticketPrice}
              specialUnit={carRentalUnit}
            />
            {!isHideReviewRating && (
              <RatingContainer>
                <ReviewStartNoPadding score={rating} starSize={13} hideScoreText />
                <ReviewsCount>({reviewCount})</ReviewsCount>
              </RatingContainer>
            )}
            {carRentalUnit && carRentalUnit.length > 0 && (
              <RatingContainer>
                <CarRentalPax>{carRentalUnit === 'Car' ? '1-3 Pax' : '1-8 Pax'}</CarRentalPax>
              </RatingContainer>
            )}
          </PriceBackground>
        </PriceContainer>
        {false && (
          <MobileButtonContainer>
            {!isHideMessage && (
              <ContactLxContainer>
                {!isHideContact && (
                  <TextLxContact onClick={() => this.setState({ isHideContact: true })}>
                    {'Hi! I\'m Local Expert'}
                    <TextBold>Can I Help you?</TextBold>
                  </TextLxContact>
                )}
                {React.cloneElement(messageButtonContainer, {}, (
                  <CoverContainer>
                    <CoverImageContainer>
                      <CoverImage
                        src={path(lx.avatar_image, 'avatarNavMini')}
                        alt={lx.name.first}
                      />
                    </CoverImageContainer>
                    <MobileMessageButton onClick={onClickMessage}>
                      <CustomIcon name="message" />
                    </MobileMessageButton>
                  </CoverContainer>
                ))}
              </ContactLxContainer>
            )}
          </MobileButtonContainer>
        )}
        {!isHideMessage && (
          <MessageButtonContainer>
            {React.cloneElement(messageButtonContainer, {}, (
              <MessageButton onClick={onClickMessage}>
                <MessageText>{messageLabel}</MessageText>
              </MessageButton>
            ))}
          </MessageButtonContainer>
        )}
        <BookButtonContainer small={trip.grouped_trips && !isMobileHideTripGroup}>
          {(trip.grouped_trips && isMobileHideTripGroup) && ( // fake book button
            <BookButton
              instant={trip.is_master_trip}
              label={label}
              onClick={this.toggleMobileTripGroup}
            />
          )}
          {(trip.grouped_trips && !isMobileHideTripGroup) && (
            <Chevron name="chevron-down" onClick={this.toggleMobileTripGroup} />
          )}
          {!trip.grouped_trips && (
            React.cloneElement(bookButtonContainer, {}, (
              <BookButton
                instant={trip.is_master_trip}
                label={label}
                onClick={onClickBook}
                disabled={disabledBook}
              />
            ))
          )}
        </BookButtonContainer>
      </PriceOuter>
    );

    return (
      <Fragment>
        <Container className={className} isGDPR={isGDPR} showTripGroup={!isMobileHideTripGroup}>
          <PriceComponent />
        </Container>
        <TripGroupContainer showTripGroup={!isMobileHideTripGroup}>
          <PriceComponent />
          <ModHR />
          <PaddingForTripGroup>
            <GroupedTripSelector hideHR />
            <br />
            <BookButtonContainer>
              {React.cloneElement(bookButtonContainer, {}, (
                <BookButton
                  instant={trip.is_master_trip}
                  label={label}
                  onClick={onClickBook}
                  disabled={disabledBook}
                />
              ))}
            </BookButtonContainer>
          </PaddingForTripGroup>
        </TripGroupContainer>
      </Fragment>
    );
  }
}

BookBar.defaultProps = {
  bookButtonContainer: <a />,
  messageButtonContainer: <a />,
  messageLabel: 'Send a Message',
};

BookBar.contextTypes = {
  path: PropTypes.func,
};

BookBar.propTypes = {
  currency: PropTypes.string,
  price: PropTypes.number,
  displayPrice: PropTypes.number,
  bookButtonContainer: PropTypes.element,
  messageButtonContainer: PropTypes.element,
  onClickBook: PropTypes.func,
  onClickMessage: PropTypes.func,
  messageLabel: PropTypes.string,
  ticketPrice: PropTypes.number,
  trip: PropTypes.object,
  className: PropTypes.string,
  isHideReviewRating: PropTypes.bool,
  user: PropTypes.object,
  isGDPR: PropTypes.bool
};

export default enhance(BookBar);
